// Image URL Helper - Fixes all problematic URLs automatically

/**
 * Fixes image URLs to use production domain
 * Handles old domains and relative paths
 */
export const fixImageUrl = (url) => {
  if (!url) return '';
  
  // Production domain
  const PRODUCTION_URL = process.env.REACT_APP_FRONTEND_URL || 'https://davetevibul.com';
  
  // Already correct URL
  if (url.startsWith(PRODUCTION_URL)) {
    return url;
  }
  
  // Old domains to fix
  const OLD_DOMAINS = [
    'https://phone-verify-alt.preview.emergentagent.com',
    'https://phone-verify-alt.preview.emergentagent.com',
    'http://localhost:8001',
    'http://127.0.0.1:8001'
  ];
  
  // Replace old domains
  for (const oldDomain of OLD_DOMAINS) {
    if (url.startsWith(oldDomain)) {
      return url.replace(oldDomain, PRODUCTION_URL);
    }
  }
  
  // Fix relative paths
  if (url.startsWith('/api/uploads/')) {
    return `${PRODUCTION_URL}${url}`;
  }
  
  // Return as-is if no fix needed (external URLs like unsplash)
  return url;
};

/**
 * Fixes array of image URLs
 */
export const fixImageUrls = (urls) => {
  if (!urls || !Array.isArray(urls)) return [];
  return urls.map(url => fixImageUrl(url));
};

/**
 * Gets image URL with automatic fixing
 * Use this instead of direct image access
 */
export const getImageUrl = (image) => {
  return fixImageUrl(image);
};
